import { useBrand } from '@curology/ui-components-web/brand/context';
import { Navigation } from '@curology/ui-components-web/react/Navigation';
import { NavigationBar } from '@curology/ui-components-web/react/Navigation/NavigationBar';
import { NavigationBrand } from '@curology/ui-components-web/react/Navigation/NavigationBrand';

import { urls } from '@/utils/urls';

const Navbar = () => {
  const brand = useBrand();
  return (
    <Navigation>
      <NavigationBar>
        <NavigationBrand
          href={urls[brand].site.url}
          aria-label="Back to Homepage"
        />
      </NavigationBar>
    </Navigation>
  );
};

export default Navbar;
